<template>
  <div id="app" class="app">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu
            @setAmount="setAmount"
            v-if="menuVisible"
            @scrollToSection="scrollToSection"
            @goToPage="goToPage"
            :currency="currency"
            :currencyValue="currencyValue"
            :currencyCode="currencyCode"
            @changeCurrency="changeCurrency"
          />
        </transition>
        <div
          class="mob menu-icon"
          @click="toggleMenu"
          :class="{ active: menuVisible }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Header
          @setAmount="setAmount"
          @scrollToSection="scrollToSection"
          @goToPage="goToPage"
          :currency="currency"
          :currencyValue="currencyValue"
          :currencyCode="currencyCode"
          @changeCurrency="changeCurrency"
        />
        <router-view
          @setAmount="setAmount"
          @topUp="topUp"
          @formatDate="formatDate"
          :currency="currency"
          :currencyCode="currencyCode"
          @openProductModal="openProductModal"
        />
        <Footer @goToPage="goToPage" />
        <transition name="fade">
          <ProductModal
            v-if="productModalIsVisible"
            @closeProductModal="closeProductModal"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <Login
            v-if="signInModalIsVisible"
            @closeSignInModal="closeSignInModal"
            @login2="login2"
          />
        </transition>
        <transition name="fade">
          <TopUpModal
            v-if="topUpModalIsVisible"
            :currency="currency"
            @setTopUpAmount="setTopUpAmount"
          />
        </transition>
        <transition name="fade">
          <OrderModal
            v-if="orderModalIsVisible"
            :currency="currency"
            @topUp="topUp"
          />
        </transition>
        <transition name="fade">
          <CheckoutModal
            v-if="checkoutModalIsVisible"
            :currency="currency"
          />
        </transition>
        <transition name="fade">
          <AgeModal v-if="ageModalIsVisible" />
        </transition>
        <CartToast />
        <div v-if="cookesModalIsVisible" class="modal-overlay">
          <div class="cookies-modal" v-if="!settingsManagerIsVisible">
            <div class="title">Cookies Unwrapped</div>
            <div class="desc">
              We use cookies to enhance your experience on our website.
              Essential cookies are necessary for basic operations and are set
              by default. We also employ additional cookies for various purposes
              that enhance your experience but are not required for core
              functions. You can adjust your cookie settings at any time. For
              more details, please refer to our Cookie Notice.
              <a class="desc" @click="goToPage('cookie')"> Cookie Notice </a>.
            </div>
            <div class="buttons">
              <button class="button" @click="declineCookies()">Decline</button>
              <button class="button" @click="acceptAllCookies()">Accept</button>
              <button class="button" @click="settingsManagerIsVisible = true">
                Manage cookies
              </button>
            </div>
          </div>
          <div v-else class="cookies-modal">
            <div class="chekbox-container">
              <label class="chekbox-label">
                <div class="chekbox-label-wrapper">
                  <input type="checkbox" v-model="cookieSettings.advertising" />
                  <div class="checkbox"></div>
                  <div class="title small">{{ $t("Advertising") }}</div>
                  <div class="desc">
                    {{
                      $t(
                        "Advertising cookies are used to make advertising messages more relevant to you."
                      )
                    }}
                  </div>
                </div>
              </label>
            </div>

            <div class="chekbox-container">
              <label class="chekbox-label">
                <div class="chekbox-label-wrapper">
                  <input
                    type="checkbox"
                    v-model="cookieSettings.customization"
                  />
                  <div class="checkbox"></div>
                  <div class="title small">
                    {{ $t("Customization Cookies") }}
                  </div>
                  <div class="desc">
                    {{
                      $t(
                        "We use these cookies to gather information on how our website is being used so we can continuously improve it."
                      )
                    }}
                  </div>
                </div>
              </label>
            </div>

            <div class="chekbox-container">
              <label class="chekbox-label">
                <div class="chekbox-label-wrapper">
                  <input
                    type="checkbox"
                    v-model="cookieSettings.functionality"
                  />
                  <div class="checkbox"></div>
                  <div class="title small">
                    {{ $t("Functionality Cookies") }}
                  </div>
                  <div class="desc">
                    {{
                      $t(
                        "These cookies improve the performance and functionality of our website but are not essential for its use."
                      )
                    }}
                  </div>
                </div>
              </label>
            </div>

            <div class="buttons">
              <button class="button" @click="acceptAllCookies">
                {{ $t("Accept all") }}
              </button>
              <button @click="saveCookieSettings" class="button">
                {{ $t("Accept selected") }}
              </button>
              <button @click="declineCookies" class="button">
                {{ $t("Decline") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Login from "./components/Login.vue";

import Header from "./components/Header.vue";
import Menu from "./components/Menu.vue";
import Footer from "./components/Footer.vue";
import ProductModal from "./components/ProductModal.vue";
import { scroller } from "vue-scrollto/src/scrollTo";
import { loadScriptsFromString } from "@/utils/load_scripts";
import TopUpModal from "./components/TopUpModal.vue";
import OrderModal from "./components/OrderModal.vue";
import CheckoutModal from "./components/CheckoutModal.vue";
import CartToast from "./components/CartToast.vue";
import AgeModal from "./components/AgeModal.vue";
import i18n from "@/plugins/i18n";
import cartService from "@/cart";

export default {
  name: "app",
  components: {
    Header,
    Menu,
    Footer,
    ProductModal,
    Login,
    TopUpModal,
    OrderModal,
    CheckoutModal,
    CartToast,
    AgeModal,
  },
  data: function () {
    return {
      languages: [],
      selectedLanguageId: null,
      ageModalIsVisible: true,
      pageLoaded: false,
      menuVisible: false,
      isAuth: false,
      error: "",
      successMessage: "",
      orderHistory: [],
      depositHistory: [],
      textPageTitle: "",
      textPageHeader: "",
      textPageContent: "",
      imgDomain: "",
      textPageList: "",
      currency: "",
      currencyValue: "",
      currencyCode: "",
      currencyOptions: [],
      hostname: "",
      productModalIsVisible: false,
      chosenProoduct: {},
      profileData: {},
      countryOptions: [],
      amount: null,
      socials: [],
      analyticsInitialized: false,
      settings: {},
      signInModalIsVisible: false,
      topUpModalIsVisible: false,
      orderModalIsVisible: false,
      checkoutModalIsVisible: false,
      topUpAmount: "",
      ip: "",
      port: "",
      cookesModalIsVisible: false,
      cookieSettings: {
        essential: true,
        advertising: false,
        customization: false,
        functionality: false,
      },
      settingsManagerIsVisible: false,
    };
  },
  watch: {
    $route(to) {
      window.scrollTo(0, 0);
      this.closeMenu();
      if (this.isAuth) {
        this.getProfileData();
      }
      // Handle static page routes
      if (to.name === "TextPage" && to.params.slug) {
        this.getTextPageContentBySlug(to.params.slug);
      }
    },
  },
  methods: {
    closeAgeModal() {
      this.ageModalIsVisible = false;
    },
    cookiesModal() {
      const cookiesAccepted = localStorage.getItem("cookie_consent");

      if (!cookiesAccepted) {
        this.cookesModalIsVisible = true;
      }
      const storedSettings = localStorage.getItem("cookie_settings");
      if (storedSettings) {
        const parsedSettings = JSON.parse(storedSettings);
        this.cookieSettings.advertising = parsedSettings.advertising || false;
        this.cookieSettings.customization =
          parsedSettings.customization || false;
        this.cookieSettings.functionality =
          parsedSettings.functionality || false;
      }
    },
    acceptAllCookies() {
      localStorage.setItem("cookie_consent", "true");
      this.cookesModalIsVisible = false;
      this.cookieSettings.advertising = true;
      this.cookieSettings.customization = true;
      this.cookieSettings.functionality = true;
      this.saveCookieSettings();
    },
    declineCookies() {
      this.cookesModalIsVisible = false;
      localStorage.setItem("cookie_consent", "false");

      // Disable all optional cookie types
      this.cookieSettings.advertising = false;
      this.cookieSettings.customization = false;
      this.cookieSettings.functionality = false;

      this.saveCookieSettings();
    },
    saveCookieSettings() {
      localStorage.setItem(
        "cookie_settings",
        JSON.stringify(this.cookieSettings)
      );
      this.cookesModalIsVisible = false;
      localStorage.setItem("cookie_consent", "true");
    },
    setTopUpAmount(amount) {
      console.log("setTopUpAmount called with amount:", amount);
      this.topUpAmount = amount;
      this.openOrderModal();
    },
    closeOrderModal() {
      this.orderModalIsVisible = false;
    },
    openOrderModal() {
      this.topUpModalIsVisible = false;
      this.orderModalIsVisible = true;
    },
    closeTopUpModal() {
      this.topUpModalIsVisible = false;
    },
    openTopUpModal() {
      this.orderModalIsVisible = false;
      this.topUpModalIsVisible = true;
    },
    openCheckoutModal() {
      this.checkoutModalIsVisible = true;
    },
    closeCheckoutModal() {
      this.checkoutModalIsVisible = false;
    },
    isFakeLoginEnabled() {
      return (
        process.env.NODE_ENV !== "production" ||
        process.env.VUE_APP_USE_FAKE_LOGIN === "true"
      );
    },
    getApiOrigin() {
      const api = process.env.VUE_APP_API || "";
      if (/^https?:\/\//i.test(api)) {
        return new URL(api).origin;
      }
      return window.location.origin;
    },
    login2(data) {
      this.error = "";
      if (this.isFakeLoginEnabled()) {
        this.openSignInModal();
        return;
      }

      this.$http
        .post(process.env.VUE_APP_API + "login", data)
        .then((res) => {
          if (res.data.status === "OK") {
            this.isAuth = true;
            this.closeSignInModal();
            this.getProfileData();
            cartService.fetchCart();
          } else {
            this.error = res.data.message || "Login failed";
          }
        })
        .catch((err) => {
          this.error = err.response?.data?.message || "Login failed";
        });
    },
    closeSignInModal() {
      this.signInModalIsVisible = false;
    },
    openSignInModal2() {
      this.signInModalIsVisible = true;
    },
    setAmount(am) {
      this.amount = am;
    },
    closeProductModal() {
      this.productModalIsVisible = false;
    },
    openProductModal(product) {
      this.productModalIsVisible = true;
      this.chosenProoduct = product;
    },
    scrollToSection(section) {
      if (this.$route.name != "Home") {
        this.$router.push({ path: "/" });
      }
      setTimeout(() => {
        const firstScrollTo = scroller();
        firstScrollTo(section);
      }, 200);
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1
      );
    },
    closeMenu() {
      this.menuVisible = false;
      document.body.style.overflow = "auto";
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      window.scrollTo(0, 0);
      if (this.menuVisible) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    menuHeight() {
      const doc = document.documentElement;
      doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    },
    openSignInModal() {
      if (this.isFakeLoginEnabled()) {
        return this.$http
          .get(window.location.origin + "/auth/test-login")
          .then((res) => {
            if (res.data.status === "ok") {
              this.isAuth = true;
              this.signInModalIsVisible = false;
              this.error = "";
              this.getProfileData();
              cartService.fetchCart();
            }
          })
          .catch(() => {});
      }

      window.location.replace(this.getApiOrigin() + "/auth/steam/redirect");
      return Promise.resolve();
    },
    logout() {
      this.$http
        .get(process.env.VUE_APP_API + "user/logout")
        .then(() => {
          this.isAuth = false;
          this.profileData = {};
          this.orderHistory = [];
          this.depositHistory = [];
          cartService.reset();
          this.$router.push({ path: "/" });
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.isAuth = false;
          }
        });
    },
    getDepositHistory() {
      this.$http
        .get(process.env.VUE_APP_API + "payments/history")
        .then((res) => {
          this.depositHistory = res.data.data;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal();
          }
        });
    },
    getOrderHistory() {
      this.$http
        .get(process.env.VUE_APP_API + "orders/history")
        .then((res) => {
          this.orderHistory = res.data.data;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.openSignInModal();
          }
        });
    },
    formatDate(num) {
      let objectDate = new Date(num * 1000);
      let day = objectDate.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      let month = objectDate.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let year = objectDate.getFullYear();

      function padTo2Digits(x) {
        return String(x).padStart(2, "0");
      }
      let hoursAndMinutes =
        padTo2Digits(objectDate.getHours()) +
        ":" +
        padTo2Digits(objectDate.getMinutes());
      let format = day + "." + month + "." + year + " " + hoursAndMinutes;

      return format;
    },
    openProduct(item) {
      this.$router.push({
        path: "/products/" + item.id,
        params: { data: item.id },
      });
      this.getProductPageContent(item.id);
    },
    goToPage(item) {
      // Handle FAQ section scroll
      if (item == "faq") {
        this.scrollToSection("#faq");
        return;
      }

      let slug;
      if (typeof item === "object" && item !== null) {
        // If an object was passed (like from v-for), use its slug from API
        slug = item.slug;
      } else {
        // First check keyword mapping (for 'cookie', 'terms', 'privacy')
        const keywordSlug = this.getSlugFromKeyword(item);

        // Try to find page by keyword slug in the list
        const page =
          Array.isArray(this.textPageList) && this.textPageList.length > 0
            ? this.textPageList.find((p) => p.slug === keywordSlug)
            : null;

        if (page) {
          // Use slug from API
          slug = page.slug;
        } else {
          // Fallback: search by title
          const pageByTitle =
            Array.isArray(this.textPageList) && this.textPageList.length > 0
              ? this.textPageList.find((p) => {
                  const searchTerm = item.toLowerCase();
                  const title = p.title.toLowerCase();
                  return title.includes(searchTerm);
                })
              : null;
          slug = pageByTitle ? pageByTitle.slug : keywordSlug;
        }
      }

      if (slug) {
        // Validate slug exists in textPageList before navigation
        if (Array.isArray(this.textPageList) && this.textPageList.length > 0) {
          const pageExists = this.textPageList.some((p) => p.slug === slug);
          if (!pageExists) {
            console.warn(`Slug "${slug}" not found in available pages`);
            this.$router.push({ name: "PageNotFound" });
            return;
          }
        }

        this.$router.push({
          name: "TextPage",
          params: { slug: slug },
        });
        this.getTextPageContentBySlug(slug);
      } else {
        console.warn("No valid slug found for item:", item);
        this.$router.push({ name: "PageNotFound" });
      }
    },
    getSlugFromKeyword(keyword) {
      // Map keywords to slugs
      const keywordMap = {
        cookie: "cookie-notice",
        terms: "terms-of-use",
        privacy: "privacy-policy",
      };
      return (
        keywordMap[keyword.toLowerCase()] ||
        keyword.toLowerCase().replace(/\s+/g, "-")
      );
    },
    getSlugFromPage(page) {
      // Generate slug from page title or use existing slug
      if (page.slug) {
        return page.slug;
      }
      if (page.title) {
        return page.title
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      }
      return null;
    },
    getTextPageContent(id) {
      // Clear existing content
      this.textPageTitle = "";
      this.textPageHeader = "";
      this.textPageContent = "";

      // Fetch specific page content
      this.$http
        .get(process.env.VUE_APP_API + "static-pages/" + id)
        .then((res) => {
          if (res.data && res.data.payload) {
            this.textPageTitle = res.data.payload.title || "";
            this.textPageContent = res.data.payload.content || "";
            this.textPageHeader = res.data.payload.header || "";
          } else {
            this.$router.push({ name: "PageNotFound" });
          }
        })
        .catch(() => {
          this.$router.push({ name: "PageNotFound" });
        });
    },
    getTextPageContentBySlug(slug) {
      // Clear existing content
      this.textPageTitle = "";
      this.textPageHeader = "";
      this.textPageContent = "";

      // API supports slug directly - use slug for request
      this.$http
        .get(process.env.VUE_APP_API + "static-pages/" + slug)
        .then((res) => {
          if (res.data && res.data.payload) {
            this.textPageTitle = res.data.payload.title || "";
            this.textPageContent = res.data.payload.content || "";
            this.textPageHeader = res.data.payload.header || "";
          } else {
            console.warn(`No content found for slug: ${slug}`);
            this.$router.push({ name: "PageNotFound" });
          }
        })
        .catch((error) => {
          console.error(`Error fetching page with slug ${slug}:`, error);
          // Only redirect to 404 if it's a 404 response from server
          if (error.response && error.response.status === 404) {
            this.$router.push({ name: "PageNotFound" });
          } else {
            // For other errors, show error message but don't redirect
            this.error = "Failed to load page content. Please try again.";
          }
        });
    },
    getSettings() {
      return this.$http
        .get(process.env.VUE_APP_API + "settings")
        .then(async (res) => {
          this.ip = res.data.payload.game_server.host;
          this.port = res.data.payload.game_server.port;
          this.settings = res.data.payload;
          const snippet = res.data.payload.google_tag;
          if (!this.analyticsInitialized && snippet) {
            await loadScriptsFromString(snippet);
            this.analyticsInitialized = true;
          }
        })
        .catch(() => {});
    },
    getTextPages() {
      this.$http
        .get(process.env.VUE_APP_API + "static-pages")
        .then((res) => {
          this.textPageList = res.data.payload;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getSocials() {
      this.$http
        .get(process.env.VUE_APP_API + "social-links")
        .then((res) => {
          this.socials = res.data.payload;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    topUp(data) {
      this.error = "";
      return this.$http
        .post(process.env.VUE_APP_API + "payments/checkout", data)
        .then((res) => {
          if (res.data.status === "OK") {
            window.location = res.data.redirect_url;
            return res.data;
          } else {
            const message = res.data.message || "Payment failed";
            this.error = message;
            return Promise.reject(new Error(message));
          }
        })
        .catch((res) => {
          if (res.response && res.response.status === 401) {
            this.openSignInModal();
          }
          const message =
            (res.response && res.response.data && res.response.data.message) ||
            res.message ||
            "Payment failed";
          this.error = message;
          return Promise.reject(new Error(message));
        });
    },
    getProfileData() {
      let self = this;
      self.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          self.getOrderHistory();
          self.getDepositHistory();
          self.profileData = res.data.payload;
        })
        .catch(() => {});
    },
    getCurrencies() {
      return this.$http
        .get(process.env.VUE_APP_API + "currencies")
        .then((res) => {
          const that = this;
          this.currencyOptions = res.data.payload;

          if (localStorage.getItem("currency")) {
            this.currencyCode = localStorage.getItem("currency");

            const currency = res.data.payload.find(
              ({ code }) => code === that.currencyCode
            );

            if (currency) {
              this.currencyValue = currency.value;
              this.currency = currency.symbol;
            }
          } else {
            this.currencyCode = this.currencyOptions[0].code;
            this.currency = this.currencyOptions[0].symbol;
            this.currencyValue = this.currencyOptions[0].value;
          }
        })
        .catch(() => {});
    },
    changeCurrency(item) {
      this.currencyCode = item;
      this.checkCurrency();
    },
    checkCurrency() {
      const that = this;
      const currency = this.currencyOptions.find(
        ({ code }) => code === that.currencyCode
      );

      if (currency) {
        this.currency = currency.symbol;
        this.currencyValue = currency.value;
        console.log(currency.symbol);

        if (this.isAuth) {
          this.getProfileData();
        }
      }
    },
    async fetchLanguagesAndSetFirst() {
      try {
        const response = await this.$http.get(
          process.env.VUE_APP_API + "languages"
        );
        if (
          response.data &&
          response.data.status === "OK" &&
          response.data.payload.length
        ) {
          this.languages = response.data.payload;
          this.selectedLanguageId = this.languages[0].id; // Set the first language
          const responseLocal = await this.$http.get(
            process.env.VUE_APP_API + "localizations",
            {
              params: { lang_id: this.selectedLanguageId },
            }
          );
          if (responseLocal.data) {
            const currentLangCode = this.currentLanguageCode;
            if (currentLangCode) {
              i18n.setLocaleMessage(currentLangCode, responseLocal.data);
              i18n.locale = currentLangCode;
            }
          }
        }
      } catch (e) {
        console.error("Failed to fetch languages or localizations:", e);
      }
    },
  },
  mounted: async function () {
    await this.fetchLanguagesAndSetFirst();
    if (localStorage.getItem("age")) {
      this.ageModalIsVisible = false;
    }
    this.cookiesModal();
    this.hostname = this.getDomainName(window.location.hostname);
    this.currency = process.env.VUE_APP_CURRENCY;
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.pageLoaded = true;
    let self = this;
    window.addEventListener("resize", self.menuHeight);
    self.getSettings();
    self.menuHeight();
    self.getTextPages();
    self.getSocials();
    self.getCurrencies();
    self.$http
      .get(process.env.VUE_APP_API + "user/is-auth")
      .then((res) => {
        self.isAuth = res.data.authenticated;

        if (self.isAuth) {
          self.getProfileData();
          cartService.fetchCart();
          return null;
        }

        if (self.isFakeLoginEnabled()) {
          return self.openSignInModal().then(() => {
            self.isAuth = true;
          });
        }
        return null;
      })
      .catch(() => {});
  },
  computed: {
    minOrderAmount: function () {
      return this.settings && this.settings.min_order_amount;
    },
    currentLanguageName() {
      const lang = this.languages.find((l) => l.id == this.selectedLanguageId);
      return lang ? lang.title : "Loading...";
    },
    currentLanguageCode() {
      const lang = this.languages.find((l) => l.id == this.selectedLanguageId);
      return lang ? lang.code : "";
    },
  },
};
</script>
